import { create } from 'zustand';

interface IPreloaderMainState {
  isHidden: boolean;
}

const usePreloaderMainStore = create<IPreloaderMainState>()((set, get) => ({
  isHidden: false
}));

export default usePreloaderMainStore;
